export default __webpack_public_path__ + "static/media/node.16e1f502.gif";